import { connect } from 'react-redux';
import { RefundExplorer } from '../../components';
import { getRefundsPaginated, addComment, updateStatus, uploadFiles, getRefundsCount, getTransactions } from '../../redux/actions/refunds';
import { getAllOperatorData as getOperatorData } from '../../redux/actions/operator';

const mapStateToProps = state => ({
  operators: state.operator.allData,
  refunds: state.refunds.data,
  pages: state.refunds.pages,
  total: state.refunds.total,
  loading: state.refunds.loading,
  refundCount: state.refunds.refundCount,
  transactions: state.refunds.transactions,
  loadingTransactions: state.refunds.loadingTransactions
});

const mapDispatchToProps = {
  getRefunds: getRefundsPaginated,
  getOperatorData,
  addComment,
  updateStatus,
  uploadFiles,
  getRefundsCount,
  getTransactions
};

export default connect(mapStateToProps, mapDispatchToProps)(RefundExplorer)



// WEBPACK FOOTER //
// ./src/containers/RefundExplorer/RefundExplorer.js